// Converte texto digitado no formato "HH:MM" (horário do lembrete diário,
// Etapa 14) para `{ hour, minute }`. Mesmo espírito de parseLocaleNumber.ts:
// `null` distingue "texto inválido" (mostrar erro) de um valor utilizável.
// Faixa validada (0–23 / 0–59) porque um trigger de notificação diária com
// hora/minuto fora da faixa é aceito silenciosamente por alguns SOs e nunca
// dispara — melhor recusar aqui do que agendar algo que nunca toca.
export interface HourMinute {
  hour: number;
  minute: number;
}

export function parseHourMinute(text: string): HourMinute | null {
  const match = text.trim().match(/^(\d{1,2}):(\d{1,2})$/);
  if (!match) return null;

  const hour = Number(match[1]);
  const minute = Number(match[2]);
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null;

  return { hour, minute };
}

/** Formata de volta para "HH:MM" (dois dígitos cada) — usado para
 * pré-popular o campo com o valor salvo. */
export function formatHourMinute({ hour, minute }: HourMinute): string {
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
}
